import * as CONSTANTS from "../../constants";

/**
 *  Authentication Mutations
 */
export default {

    /**
     * Indicates that a login request is pending
     *
     * @param state
     */
    [CONSTANTS.AUTH_LOGIN_PENDING] (state) {
        state.login = { ...state.login, loading: true, message: undefined };
    },

    /**
     * Indicates that a login request is successful
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_LOGIN_SUCCESS] (state, payload) {
        state.login = { ...state.login, loading: true, message: undefined };
        state.originalUser = {...{}, ...payload.user};
        state.user = {...{}, ...payload.user};
        state.suppliers = payload.suppliers;
        // Chose the first supplier in the supplier list
        state.supplier = {...state.supplier, ...payload.suppliers[0]};
    },

    /**
     * Indicates that a login request has failed..
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_LOGIN_FAILURE] (state, payload) {
        state.login = { ...state.login, loading: false, message: payload };
    },

    /**
     * Indicates that a "Forgot Password" request is pending
     *
     * @param state
     */
    [CONSTANTS.AUTH_FORGOT_PENDING] (state) {
        state.forgot = { ...state.forgot, loading: true, message: undefined };
    },

    /**
     * Indicates that a "Forgot Password" request has succeeded
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_FORGOT_SUCCESS] (state, payload) {
        state.forgot = { ...state.forgot, loading: false, message: payload };
    },

    /**
     * Indicates that a "Forgot Password" request has failed
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_FORGOT_FAILURE] (state, payload) {
        state.forgot = { ...state.forgot, loading: false, message: payload };
    },

    /**
     * Indicates that a "Reset Password" request is pending
     *
     * @param state
     */
    [CONSTANTS.AUTH_RESET_PENDING] (state) {
        state.reset = { ...state.reset, loading: true, message: undefined };
    },

    /**
     * Indicates that a "Reset Password" request has succeeded
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_RESET_SUCCESS] (state, payload) {
        state.reset = { ...state.reset, loading: false, message: payload };
    },

    /**
     * Indicates that a "Reset Password" request has failed
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_RESET_FAILURE] (state, payload) {
        state.reset = { ...state.reset, loading: false, message: payload };
    },

    /**
     * Sets the user in the state to the provided payload
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_USER_SET] (state, payload) {
        state.user = {...state.user, ...payload};
    },

    /**
     * Unsets the user in the state
     *
     * @param state
     */
    [CONSTANTS.AUTH_USER_UNSET] (state) {
        state.user = null;
        state.login = { ...state.login, loading: false };
    },

    /**
     * Sets the supplier in the state to the provided payload
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_SUPPLIER_SET] (state, payload) {
        state.supplier = payload;
    },

    /**
     * Set the suppliers in the state.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_SUPPLIERS_SET] (state, payload) {
        state.suppliers = payload
    },

    /**
     * Unsets the supplier in the state
     *
     * @param state
     */
    [CONSTANTS.AUTH_SUPPLIER_UNSET] (state) {
        state.supplier = null;
    },

    /**
     * Indicates that a user activation request is pending
     *
     * @param state
     */
    [CONSTANTS.AUTH_ACTIVATION_PENDING] (state) {
        state.activation = { ...state.activation, loading: true, message: undefined };
    },

    /**
     * Indicates that a user activation request succeeded
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_ACTIVATION_SUCCESS] (state, payload) {
        state.activation = { ...state.activation, loading: false, message: payload };
    },

    /**
     * Indicates that a user activation request failed
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_ACTIVATION_FAILURE] (state, payload) {
        state.activation = { ...state.activation, loading: false, message: payload };
    },

    /**
     * Sets a notice for the login page
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_MESSAGE_SET] (state, payload) {
        state.login.message = payload;
    },

    /**
     * Set the referrer path.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_REFERRER_SET] (state, payload) {
        state.referrer = payload;
    },

    /**
     * Unset the referrer path.
     *
     * @param state
     */
    [CONSTANTS.AUTH_REFERRER_UNSET] (state) {
        state.referrer = undefined
    },

    /**
     * Set the supplier.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_SUPPLIER_SET] (state, payload) {
        state.supplier = payload;
    },

    /**
     * Set the product type.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_PRODUCT_TYPE_SET] (state, payload) {
        state.productType = payload;
    },

    /**
     * Indicates that the suppliers and products are being fetched.
     *
     * @param state
     */
    [CONSTANTS.AUTH_SUPPLIERS_PRODUCTS_LIST_PENDING] (state) {
        state.suppliersProducts = {...state.suppliersProducts, loading: true, error: false}
    },

    /**
     * Indicates that the suppliers and products was fetched successfully.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_SUPPLIERS_PRODUCTS_LIST_SUCCESS] (state, payload) {
        state.suppliersProducts = {...state.suppliersProducts, loading: false, error: false, items: payload}
    },

    /**
     * Indicates that the suppliers and products was fetched unsuccessfully.
     *
     * @param state
     */
    [CONSTANTS.AUTH_SUPPLIERS_PRODUCTS_LIST_FAILURE] (state) {
        state.suppliersProducts = {...state.suppliersProducts, loading: false, error: true}
    },

    /**
     * Set the product types.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.AUTH_PRODUCT_TYPES_SET] (state, payload) {
        state.productTypes = payload;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js